
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gMGbk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1qfLF = parcelRequire("1qfLF");


var $jQW4q = parcelRequire("jQW4q");


var $3gadb = parcelRequire("3gadb");


var $inPa6 = parcelRequire("inPa6");





var $gCqjE = parcelRequire("gCqjE");

var $4iTbK = parcelRequire("4iTbK");

var $9hBBk = parcelRequire("9hBBk");


var $1AJi3 = parcelRequire("1AJi3");


var $er2Wy = parcelRequire("er2Wy");


var $3rRes = parcelRequire("3rRes");

/**
 * Block types that become direct siblings in page remix `fragmentAdf` after flattening.
 * Containers (layouts, lists, tables, panels, …) are unwrapped so the result matches a
 * linear `doc.content`-style array of block nodes in document order.
 */ const $75827a28e24fdaa7$var$FRAGMENT_ROOT_BLOCK_TYPES = new Set([
    'paragraph',
    'heading',
    'codeBlock',
    'rule'
]);
function $75827a28e24fdaa7$var$flattenRemixFragmentNodes(nodes) {
    if (!nodes?.length) return [];
    const out = [];
    const stack = [
        ...nodes
    ].reverse();
    while(stack.length){
        const node = stack.pop();
        if (!node || typeof node !== 'object' || !('type' in node)) continue;
        const nodeType = String(node.type);
        if ((0, $er2Wy.isRemixRestrictedNodeType)(nodeType)) continue;
        if ($75827a28e24fdaa7$var$FRAGMENT_ROOT_BLOCK_TYPES.has(nodeType)) {
            const filtered = (0, $3rRes.filterRemixFragmentNodes)([
                node
            ]);
            if (filtered?.length) out.push(...filtered);
            continue;
        }
        const content = node.content;
        if (content?.length) stack.push(...[
            ...content
        ].reverse());
    }
    return out;
}
function $75827a28e24fdaa7$export$aba2b401f8bd2a68(adfDocument) {
    return $75827a28e24fdaa7$var$flattenRemixFragmentNodes(adfDocument.content ?? []);
}



var $7eOZ4 = parcelRequire("7eOZ4");

const $28574250ff4b29d3$var$constructPageDynamicUiSource = (adfDocument)=>({
        contentType: 'page',
        startLocalId: '',
        endLocalId: '',
        startIndex: 0,
        endIndex: -1,
        fragmentAdf: (0, $75827a28e24fdaa7$export$aba2b401f8bd2a68)(adfDocument),
        fullAdf: adfDocument
    });
const $28574250ff4b29d3$export$6d573f1103e8ba17 = ({ adfDocument: adfDocument, interactionSource: interactionSource, onClose: onClose, onStartThinking: onStartThinking, onStopThinking: onStopThinking, isEphemeralViewVisible: isEphemeralViewVisible, trigger: trigger, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen })=>{
    const isRemixCancelled = (0, $42omo.useRef)(false);
    const openAIFCStagingModalRef = (0, $42omo.useRef)(()=>{});
    const onActionReady = (0, $42omo.useCallback)(()=>{
        if (!isRemixCancelled.current) {
            openAIFCStagingModalRef.current();
            onStopThinking();
            onClose();
        }
    }, [
        onClose,
        onStopThinking
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal } = (0, $7eOZ4.useRemixToAIFC)({
        onActionReady: onActionReady
    });
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    const { toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onRemixFlowActiveChange = (0, $42omo.useCallback)((active)=>{
        if (active) {
            isRemixCancelled.current = false;
            onStartThinking();
        } else {
            isRemixCancelled.current = true;
            stopRemixing();
            onStopThinking({
                reopenModal: true
            });
        }
    }, [
        onStartThinking,
        stopRemixing,
        onStopThinking
    ]);
    const prevIsRemixError = (0, $42omo.useRef)(isRemixError);
    (0, $42omo.useEffect)(()=>{
        if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) onStopThinking({
            reopenModal: true
        });
        prevIsRemixError.current = isRemixError;
    }, [
        isRemixError,
        onStopThinking
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isRemixCancelled.current && isRemixError) {
            if (isEphemeralViewVisible) closeAIFCStagingModal();
            onStopThinking();
            onClose();
            toggleConversationAssistant('sidebar');
        }
    }, [
        isRemixError,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        toggleConversationAssistant
    ]);
    const handleOptionSelect = (0, $42omo.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
        const dynamicUiSource = $28574250ff4b29d3$var$constructPageDynamicUiSource(adfDocument);
        await sendAIFCPrompt({
            userPrompt: userPrompt,
            dynamicUiType: type,
            dynamicUiSubtype: subType,
            dynamicUiSource: dynamicUiSource,
            interactionSource: interactionSource
        });
    }, [
        sendAIFCPrompt,
        adfDocument,
        interactionSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iTbK.RemixContainer), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: isEphemeralViewVisible,
        options: (0, $gCqjE.PAGE_REMIX_OPTIONS),
        subtitle: (0, $9hBBk.remixOverlayMessages).pageRemixSubtitle,
        presentation: "popup",
        trigger: trigger,
        popupPlacement: popupPlacement,
        popupOffset: popupOffset,
        isPopupOpen: isPopupOpen
    });
};



var $aXWtB = parcelRequire("aXWtB");


var $jyA9t = parcelRequire("jyA9t");


var $8uM2K = parcelRequire("8uM2K");


var $aHcFH = parcelRequire("aHcFH");

const $e7d7957021bd9d4a$var$remixButtonContainerStyle = null;
const $e7d7957021bd9d4a$var$i18n = (0, $h82at.defineMessages)({
    remixPageLabel: {
        id: "object-sidebar-components.remix-page.label",
        defaultMessage: "Remix page"
    },
    remixPageTooltip: {
        id: "object-sidebar-components.remix-page.tooltip",
        defaultMessage: "Remix"
    },
    remixPageEmptyTooltip: {
        id: "object-sidebar-components.remix-page.empty-tooltip",
        defaultMessage: "Add content to this page to remix"
    },
    remixInProgressTooltip: {
        id: "object-sidebar-components.remix-page.in-progress-tooltip",
        defaultMessage: "Remix in progress"
    }
});
const $e7d7957021bd9d4a$var$parseAdf = (value)=>{
    try {
        const parsed = JSON.parse(value);
        if (!parsed || parsed.type !== 'doc') return null;
        return parsed;
    } catch  {
        return null;
    }
};
const $e7d7957021bd9d4a$export$def261f8e2f8a585 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(35);
    const { contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument, isEditorEmpty: isEditorEmpty, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [isThinking, setIsThinking] = (0, $42omo.useState)(false);
    const [lazyAdfDocument, setLazyAdfDocument] = (0, $42omo.useState)(null);
    const [viewOpenAdfDocument, setViewOpenAdfDocument] = (0, $42omo.useState)(null);
    let t2;
    bb0: {
        if (getAdfDocument) {
            t2 = false;
            break bb0;
        }
        if (!contentBodyValue) {
            t2 = false;
            break bb0;
        }
        let t3;
        if ($[0] !== contentBodyValue) {
            const parsed = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
            t3 = parsed !== null && !(0, $aHcFH.isEmptyAdf)(parsed);
            $[0] = contentBodyValue;
            $[1] = t3;
        } else t3 = $[1];
        t2 = t3;
    }
    const hasContentFromBody = t2;
    const hasContent = getAdfDocument ? !isEditorEmpty : hasContentFromBody;
    const isRemixInProgress = isModalOpen || isThinking || showSmartCreationModal;
    const resolvedAdfDocument = getAdfDocument ? lazyAdfDocument : viewOpenAdfDocument;
    let t3;
    if ($[2] !== contentBodyValue || $[3] !== createAnalyticsEvent || $[4] !== getAdfDocument || $[5] !== hasContent || $[6] !== isRemixInProgress) {
        t3 = async ()=>{
            if (!hasContent || isRemixInProgress) return;
            if (getAdfDocument) {
                const doc = await getAdfDocument();
                if (doc) {
                    setLazyAdfDocument(doc);
                    setIsModalOpen(true);
                }
            } else if (contentBodyValue) {
                const doc_0 = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
                if (doc_0) {
                    setViewOpenAdfDocument(doc_0);
                    setIsModalOpen(true);
                }
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "remixPage",
                    source: "objectSidebar"
                }
            }).fire();
        };
        $[2] = contentBodyValue;
        $[3] = createAnalyticsEvent;
        $[4] = getAdfDocument;
        $[5] = hasContent;
        $[6] = isRemixInProgress;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsModalOpen(false);
            setIsThinking(false);
            setViewOpenAdfDocument(null);
            setLazyAdfDocument(null);
        };
        $[8] = t4;
    } else t4 = $[8];
    const closeModal = t4;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setIsThinking(true);
            setIsModalOpen(false);
        };
        $[9] = t5;
    } else t5 = $[9];
    const onStartThinking = t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (options)=>{
            setIsThinking(false);
            if (options?.reopenModal) setIsModalOpen(true);
        };
        $[10] = t6;
    } else t6 = $[10];
    const onStopThinking = t6;
    const isSmartCreationModalOpen = (0, $42omo.useRef)(false);
    let t7;
    let t8;
    if ($[11] !== isThinking || $[12] !== showSmartCreationModal) {
        t7 = ()=>{
            if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking) onStopThinking();
            isSmartCreationModalOpen.current = showSmartCreationModal;
        };
        t8 = [
            showSmartCreationModal,
            isThinking,
            onStopThinking
        ];
        $[11] = isThinking;
        $[12] = showSmartCreationModal;
        $[13] = t7;
        $[14] = t8;
    } else {
        t7 = $[13];
        t8 = $[14];
    }
    (0, $42omo.useLayoutEffect)(t7, t8);
    let t9;
    if ($[15] !== formatMessage || $[16] !== hasContent || $[17] !== isRemixInProgress) {
        t9 = isRemixInProgress ? formatMessage($e7d7957021bd9d4a$var$i18n.remixInProgressTooltip) : hasContent ? formatMessage($e7d7957021bd9d4a$var$i18n.remixPageTooltip) : formatMessage($e7d7957021bd9d4a$var$i18n.remixPageEmptyTooltip);
        $[15] = formatMessage;
        $[16] = hasContent;
        $[17] = isRemixInProgress;
        $[18] = t9;
    } else t9 = $[18];
    const tooltipContent = t9;
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resolvedAdfDocument) {
        t11 = resolvedAdfDocument ?? {
            type: "doc",
            version: 1,
            content: []
        };
        $[20] = resolvedAdfDocument;
        $[21] = t11;
    } else t11 = $[21];
    const t12 = isModalOpen || isThinking;
    let t13;
    if ($[22] !== formatMessage || $[23] !== handleClick || $[24] !== hasContent || $[25] !== isDisabled || $[26] !== isRemixInProgress || $[27] !== isRovoButtonEnabled || $[28] !== tooltipContent) {
        t13 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                position: "left",
                content: tooltipContent,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                onClick: handleClick,
                appearance: "subtle",
                shape: isRovoButtonEnabled ? "default" : "circle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
                label: formatMessage($e7d7957021bd9d4a$var$i18n.remixPageLabel),
                testId: "sidebar-remix-button",
                isDisabled: isDisabled || !hasContent || isRemixInProgress
            }));
        $[22] = formatMessage;
        $[23] = handleClick;
        $[24] = hasContent;
        $[25] = isDisabled;
        $[26] = isRemixInProgress;
        $[27] = isRovoButtonEnabled;
        $[28] = tooltipContent;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== showSmartCreationModal || $[31] !== t11 || $[32] !== t12 || $[33] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $28574250ff4b29d3$export$6d573f1103e8ba17), {
            adfDocument: t11,
            onClose: closeModal,
            onStartThinking: onStartThinking,
            onStopThinking: onStopThinking,
            isEphemeralViewVisible: showSmartCreationModal,
            popupPlacement: "left-end",
            isPopupOpen: t12,
            trigger: t13
        })));
        $[30] = showSmartCreationModal;
        $[31] = t11;
        $[32] = t12;
        $[33] = t13;
        $[34] = t14;
    } else t14 = $[34];
    return t14;
} : ({ contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument, isEditorEmpty: isEditorEmpty, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [isThinking, setIsThinking] = (0, $42omo.useState)(false);
    const [lazyAdfDocument, setLazyAdfDocument] = (0, $42omo.useState)(null);
    const [viewOpenAdfDocument, setViewOpenAdfDocument] = (0, $42omo.useState)(null);
    const hasContentFromBody = (0, $42omo.useMemo)(()=>{
        if (getAdfDocument) return false;
        if (!contentBodyValue) return false;
        const parsed = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
        return parsed !== null && !(0, $aHcFH.isEmptyAdf)(parsed);
    }, [
        contentBodyValue,
        getAdfDocument
    ]);
    const hasContent = getAdfDocument ? !isEditorEmpty : hasContentFromBody;
    const isRemixInProgress = isModalOpen || isThinking || showSmartCreationModal;
    const resolvedAdfDocument = getAdfDocument ? lazyAdfDocument : viewOpenAdfDocument;
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        if (!hasContent || isRemixInProgress) return;
        if (getAdfDocument) {
            const doc = await getAdfDocument();
            if (doc) {
                setLazyAdfDocument(doc);
                setIsModalOpen(true);
            }
        } else if (contentBodyValue) {
            const doc_0 = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
            if (doc_0) {
                setViewOpenAdfDocument(doc_0);
                setIsModalOpen(true);
            }
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remixPage',
                source: 'objectSidebar'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasContent,
        isRemixInProgress,
        getAdfDocument,
        contentBodyValue
    ]);
    const closeModal = (0, $42omo.useCallback)(()=>{
        setIsModalOpen(false);
        setIsThinking(false);
        setViewOpenAdfDocument(null);
        setLazyAdfDocument(null);
    }, []);
    const onStartThinking = (0, $42omo.useCallback)(()=>{
        setIsThinking(true);
        setIsModalOpen(false);
    }, []);
    const onStopThinking = (0, $42omo.useCallback)((options)=>{
        setIsThinking(false);
        if (options?.reopenModal) setIsModalOpen(true);
    }, []); // Stop thinking when the ephemeral preview (smart creation modal) is closed
    // while thinking is still active, to prevent the thinking bar from reappearing.
    // This matches the pattern used in EditorRemixCreator's Wrapper component.
    const isSmartCreationModalOpen = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking) onStopThinking();
        isSmartCreationModalOpen.current = showSmartCreationModal;
    }, [
        showSmartCreationModal,
        isThinking,
        onStopThinking
    ]);
    const tooltipContent = isRemixInProgress ? formatMessage($e7d7957021bd9d4a$var$i18n.remixInProgressTooltip) : hasContent ? formatMessage($e7d7957021bd9d4a$var$i18n.remixPageTooltip) : formatMessage($e7d7957021bd9d4a$var$i18n.remixPageEmptyTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $28574250ff4b29d3$export$6d573f1103e8ba17), {
        adfDocument: resolvedAdfDocument ?? {
            type: 'doc',
            version: 1,
            content: []
        },
        onClose: closeModal,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        popupPlacement: "left-end",
        isPopupOpen: isModalOpen || isThinking,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                position: "left",
                content: tooltipContent,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                onClick: handleClick,
                appearance: "subtle",
                shape: isRovoButtonEnabled ? 'default' : 'circle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
                label: formatMessage($e7d7957021bd9d4a$var$i18n.remixPageLabel),
                testId: "sidebar-remix-button",
                isDisabled: isDisabled || !hasContent || isRemixInProgress
            }))
    })));
};
module.exports["RemixPanelButton"] = $e7d7957021bd9d4a$export$def261f8e2f8a585;

});

parcelRegister("jQW4q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7739ad8bf36e5bd9a55f1766d10483c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e73feb3a782b379c$var$_react = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("42omo")));

var $e73feb3a782b379c$var$_baseNew = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e73feb3a782b379c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e73feb3a782b379c$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $e73feb3a782b379c$var$_react.default.createElement($e73feb3a782b379c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$e73feb3a782b379c$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $e73feb3a782b379c$var$_default = module.exports.default = $e73feb3a782b379c$var$AiGenerativeRemixIcon;

});

parcelRegister("1AJi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("4Gau4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $ig6yX = parcelRequire("ig6yX");


var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

const $c747837ed372cb4a$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $c747837ed372cb4a$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $c747837ed372cb4a$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizingHeight"] = $c747837ed372cb4a$export$da99457d6430d83;

});

parcelRegister("1uunn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $8gGM0 = parcelRequire("8gGM0");

const $90ef72367fab294b$var$fetchProfileData = (0, $2XqLN.default)(async ()=>{
    const data = await (0, $8gGM0.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email,
        organization: data.extended_profile?.organization
    };
});
const $90ef72367fab294b$export$3c814b55c7cbb1fb = (0, $42omo.createContext)(null);
const $90ef72367fab294b$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $90ef72367fab294b$export$68afc71177137005 = (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $42omo.useState)($90ef72367fab294b$var$emptyProfileData);
    const profileContextData = (0, $42omo.useContext)($90ef72367fab294b$export$3c814b55c7cbb1fb);
    (0, $42omo.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $90ef72367fab294b$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($90ef72367fab294b$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $90ef72367fab294b$export$68afc71177137005;

});

parcelRegister("8gGM0", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $2f3ab166c93f3263$export$3e32638432616b6 = async ()=>{
    const response = await (0, $8Igpw.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $2f3ab166c93f3263$export$3e32638432616b6;

});

parcelRegister("ew8wg", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $duklN = parcelRequire("duklN");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), t1);
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});

parcelRegister("duklN", function(module, exports) {
/**
 * @generated SignedSource<<da89cb632be3a889b86eac8faea94e6e>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b
const $78d6c4b2c14ab559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "512d3c288e476ca23b45061d9102b2d6",
            "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
            "metadata": {},
            "name": "usePageTitlePageTitleQuery",
            "operationKind": "query",
            "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
        }
    };
}();
$78d6c4b2c14ab559$var$node.hash = "49163e20c25d3da0c01ad2e924f87c37";
var $78d6c4b2c14ab559$export$2e2bcd8739ae039 = $78d6c4b2c14ab559$var$node;
module.exports["default"] = $78d6c4b2c14ab559$export$2e2bcd8739ae039;

});

parcelRegister("aouqA", function(module, exports) {

var $ajfvU = parcelRequire("ajfvU");

function $79be80eb0ef13a18$export$5650c329b9f287fb() {
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $ajfvU.useChatStore)();
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $ajfvU.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    return {
        createConversationOptimistically: createConversationOptimistically,
        setSelectedConversation: setSelectedConversation,
        abortRequests: abortRequests,
        activeConversationId: currentConversationId,
        activeConversation: activeConversation,
        sendMessage: sendMessage,
        seedConversation: seedConversation,
        processConversationMessages: $ajfvU.processConversationMessages
    };
}
module.exports["useSmartCreationChatStoreApi"] = $79be80eb0ef13a18$export$5650c329b9f287fb;

});


//# sourceMappingURL=RemixPanelButton.18b3aa72.js.map
